<template>
  <div class="home">
    <b-img alt="Wappen der PV Bund" src="/public/downloads/directories/images/Wappen.png" fluid />
    <LandingPage msg="Willkommen bei der PV Bund 1895 zu Bruchsal"/>
  </div>
</template>

<script>
// @ is an alias to /src
import LandingPage from '@/components/LandingPage.vue'

export default {
  name: 'home',
  components: {
    LandingPage
  }
}
</script>
